import { IShopifyFooterSection, shopifyFooterSections } from '../shopifyFooterSections';

export function useFetchFooterLinks (): IShopifyFooterSection[] {
    return shopifyFooterSections;
}
